import React, { useEffect, useState} from 'react';
import { Alert, Modal } from 'react-bootstrap';
import apiClient from "../../helpers/api";
import { useForm, } from "react-hook-form";


const Cta = (props) => {

    const [showModal, setShowModal] = useState(false);
    const [inClickLoading,setIsClickLoading] = useState(false)
    
    const [successMessage,setSuccessMessage] = useState('')
    const {register, handleSubmit, setError, formState:{errors, isDirty, isValid }, formState, reset} = useForm({ mode: 'onBlur' })
    const {isSubmitting} = formState;


    const openModalForm = (art) => {
        setShowModal(true)
    }

    const closeModal = () => {
        setShowModal(false)
    }

    const onSubmitCta = (data) => {
        try { 
            setIsClickLoading(true)
           
            apiClient.post(`${process.env.REACT_APP_API}/cta/submit`, data).then(res => {
                reset()

                setSuccessMessage(res.data.msg)

                setTimeout(()=>{
                    setSuccessMessage('')
                }, 5000)

                setIsClickLoading(false)
            }).catch(error => {
                if (error.response.data) {
                    setIsClickLoading(false)
                    const errors = error.response.data.errors
                }
            })

        } catch (error) {
            console.log(error);
        }

    }

        return (
            <>
            <div className="container py-5 px-3 text-center text-black text-capitalize">
                <button onClick={openModalForm} className="btn btn-danger text-uppercase">{props.content.label}</button>
            </div>
            <Modal size="md" aria-labelledby="contained-modal-title-vcenter" centered show={showModal}>
            <Modal.Header className="pb-0">
                <p className="font-weight-bold pt-3 text-uppercase">{props.content.label}</p> <button type="button" className="btn btn-dark btn-sm rounded-0 p-2" onClick={closeModal}>x</button> 
            </Modal.Header>
            <Modal.Body className="pt-0">
                {
                    successMessage ? <div className='alert alert-success'>{successMessage}</div> : ''
                }
                <form onSubmit={handleSubmit(onSubmitCta)} className="row">
                    <div  className="col-md-12">
                        <div className="form-group mt-3">
                            <label>Name</label>
                            <input type="text" className="form-control" {...register("name",{required:true})} required=""></input>
                        </div>
                        <div className="form-group mt-3">
                            <label>Email</label>
                            <input type="email" className="form-control" {...register("email",{required:true})}  required=""></input>
                        </div>
                        <div className="form-group mt-3">
                            <label>Contact No</label>
                            <input type="text" className="form-control" {...register("contact_no",{required:true})} required=""></input>
                        </div>
                        <div className="form-group mt-3">
                            <label>Message</label>
                            <textarea className="form-control" {...register("message",{required:true})}> </textarea>
                        </div>
                        <input {...register("subject")} type='hidden' value={props.content.subject}></input>
                    </div>
                    <div class="col-12">
                        {
                            !isSubmitting && !inClickLoading ? 
                            <button style={{padding: '11px 15px'}}   className="btn btn-danger w-100 mt-2 mt-sm-3 "> Submit </button> 
                            : <><span className="spinner-border spinner-border-sm mr-1"></span> processing please wait</>
                        }
                                          
                     </div>
                </form>
            </Modal.Body>
            </Modal>
            </>
        )
    // }
}

export default Cta;